module.exports = __webpack_public_path__ + "media/03.42935d68.mp3";